import { ActionElement, QueryBuilder, RuleGroupTypeIC } from 'react-querybuilder';
import { QueryBuilderDnD } from '@react-querybuilder/dnd';
import RemoveAction from '../QueryBuilder/RemoveAction';
import React, { useState } from 'react';
import * as ReactDnD from 'react-dnd';
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend';
import TextField from '@mui/material/TextField';
import DropdownAutocomplete from '@/components/FormFields/DropdownAutocomplete';

export const URL_PARAM_OPERATORS = [
  { name: '=', label: 'equals (=)' },
  { name: '!=', label: 'not equals (!=)' },
  { name: 'contains', label: 'contains' },
  { name: 'is empty', label: 'is empty' },
  { name: 'is not empty', label: 'is not empty' },
];

const VALUE_HIDDEN_OPERATORS = new Set(['is empty', 'is not empty']);

const CustomParamNameEditor = (props: any) => (
  <TextField
    type='text'
    value={props.value || ''}
    placeholder='param name'
    onChange={(e) => props.handleOnChange(e.target.value)}
    onBlur={props.onBlur}
  />
);

const CustomOperatorSelector = (props: any) => {
  const currentLabel = URL_PARAM_OPERATORS.find((op) => op.name === props.value)?.label ?? props.value;
  return (
    <DropdownAutocomplete
      value={currentLabel}
      options={URL_PARAM_OPERATORS.map((op) => op.label)}
      onChange={(label: string) => {
        const op = URL_PARAM_OPERATORS.find((o) => o.label === label);
        if (op) props.handleOnChange(op.name);
      }}
      onBlur={props.onBlur}
      sx={{ width: '100%' }}
    />
  );
};

const CustomValueEditor = (props: any) => {
  if (VALUE_HIDDEN_OPERATORS.has(props.operator)) {
    return null;
  }
  return (
    <TextField
      type='text'
      value={props.value || ''}
      placeholder='param value'
      onChange={(e) => props.handleOnChange(e.target.value)}
      onBlur={props.onBlur}
    />
  );
};

const CustomCombinatorSelector = (props: any) => (
  <DropdownAutocomplete
    value={props.value.toUpperCase()}
    options={['AND', 'OR']}
    onChange={(value) => props.handleOnChange(value)}
    onBlur={props.onBlur}
    sx={{ width: '100px', flexShrink: 0 }}
  />
);

export const UrlParameter = (props: any) => {
  const defaultQuery: RuleGroupTypeIC = {
    rules: [{ field: '', operator: '=', value: '' }],
  };

  const [query, setQuery] = useState<RuleGroupTypeIC>(props?.input?.value || defaultQuery);
  const { onChange } = props.input;

  const handleQueryChange = (newQuery: RuleGroupTypeIC) => {
    setQuery(newQuery);
    onChange(newQuery);
  };

  return (
    <div className='queryBuilder'>
      <QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
        <QueryBuilder
          fields={[{ name: 'urlParam', label: 'URL Param' }]}
          operators={URL_PARAM_OPERATORS}
          query={query}
          onQueryChange={handleQueryChange}
          independentCombinators={true}
          disabled={props.disabled}
          controlElements={{
            fieldSelector: CustomParamNameEditor,
            operatorSelector: CustomOperatorSelector,
            valueEditor: CustomValueEditor,
            combinatorSelector: CustomCombinatorSelector,
            addGroupAction: (aeProps) => (aeProps.level === 0 ? <ActionElement {...aeProps} /> : null),
            removeRuleAction: RemoveAction,
            removeGroupAction: RemoveAction,
          }}
          addRuleToNewGroups
          getDefaultField={() => ''}
          getDefaultOperator={() => '='}
          getDefaultValue={() => ''}
        />
      </QueryBuilderDnD>
    </div>
  );
};
